

//V2
// src/components/chart9.js



import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart2 = ({ value = 0, label = "", size = "large" }) => {
  // Valor REAL (puede ser > 100)
  const displayPct = useMemo(() => {
    const v = Number(value);
    return Number.isFinite(v) ? v : 0;
  }, [value]);

  // Valor para el ARCO (clamp 0–100)
  const arcPct = useMemo(() => {
    return Math.max(0, Math.min(100, displayPct));
  }, [displayPct]);

  const data = useMemo(
    () => ({
      datasets: [
        {
          data: [arcPct, 100 - arcPct],
          backgroundColor: ["#0084ff", "#e5e7eb"],
          borderWidth: 0,
          cutout: size === "large" ? "70%" : "75%",
        },
      ],
    }),
    [arcPct, size]
  );

  const options = useMemo(
    () => ({
      plugins: {
        legend: { display: false },
        tooltip: { enabled: false },
      },
      maintainAspectRatio: false,
    }),
    []
  );

  return (
    <div className={`doughnut-wrapper ${size}`}>
      <Doughnut data={data} options={options} />
      <div className="doughnut-center">
        <span className="doughnut-value">{displayPct.toFixed(2)}%</span>
        <span className="doughnut-label">{label}</span>
      </div>
    </div>
  );
};

export default DoughnutChart2;